module.exports = {
  id: 'bookingForm',
  method: 'post',
  action: '/actions/futurium/forms/booking-inquiry',
  labelWidth: 220,
  cells: [
    {
      fieldType: 'infoText',
      copy: '<h2>VermietungsAnfrage</h2>'
    },
    {
      fieldType: 'infoText',
      copy: '<p>Sie planen eine Veranstaltung im Futurium? Bevor wir Ihnen die Vermietung unserer Räume zusagen können, prüfen wir, ob sich Ihre Veranstaltung inhaltlich mit dem Gesellschaftszweck des Futuriums deckt: <b>Bildung, Forschung, Wissenschaft</b> oder ein relevanter <b>Zukunftsaspekt</b>.<br><br>Auskünfte unter <a href="mailto:vermietung@futurium.de">vermietung@futurium.de</a> und +49 (0)30 408 18 97-93 oder -95.</p>'
    },
    {
      fieldType: 'infoText',
      copy: '<h3>KONTAKTDATEN</h3>'
    },
    {
      fieldType: 'input',
      name: 'organizer',
      label: 'Veranstalter\n*in',
      required: true
    },
    {
      modifier: 'half',
      fieldType: 'input',
      name: 'address',
      label: 'Anschrift',
      required: true
    },
    {
      modifier: 'quarter',
      fieldType: 'input',
      name: 'zip',
      label: 'PLZ',
      required: true
    },
    {
      modifier: 'quarter',
      fieldType: 'input',
      name: 'city',
      label: 'Ort',
      required: true
    },
    {
      modifier: 'half',
      fieldType: 'input',
      name: 'department',
      label: 'Abteilung'
    },
    {
      modifier: 'half',
      fieldType: 'input',
      name: 'position',
      label: 'Funktion'
    },
    {
      modifier: 'half',
      fieldType: 'input',
      name: 'lastName',
      label: 'Name',
      required: true
    },
    {
      modifier: 'half',
      fieldType: 'input',
      name: 'firstName',
      label: 'Vorname',
      required: true
    },
    {
      fieldType: 'input',
      name: 'email',
      type: 'email',
      label: 'E-Mail-Adresse',
      required: true
    },
    {
      fieldType: 'infoText',
      copy: '<h4>Sofern zutreffend: Von dem*r Veranstalter*in beauftragte Agentur</h4>'
    },
    {
      fieldType: 'input',
      name: 'agencyNameFull',
      label: 'Agentur',
      placeholder: 'beauftragte Agentur oder Ausführende*r'
    },
    {
      modifier: 'half',
      fieldType: 'input',
      name: 'agencyAddress',
      label: 'Anschrift'
    },
    {
      modifier: 'quarter',
      fieldType: 'input',
      name: 'agencyZip',
      label: 'PLZ'
    },
    {
      modifier: 'quarter',
      fieldType: 'input',
      name: 'agencyCity',
      label: 'Ort'
    },
    {
      modifier: 'half',
      fieldType: 'input',
      name: 'agencyLastName',
      label: 'Name'
    },
    {
      modifier: 'half',
      fieldType: 'input',
      name: 'agencyFirstName',
      label: 'Vorname'
    },
    {
      fieldType: 'input',
      name: 'agencyEmail',
      type: 'email',
      label: 'E-Mail-Adresse'
    },
    {
      fieldType: 'infoText',
      copy: '<h3>ANGABEN ZUR VERANSTALTUNG</h3><p>Das Futurium kann für einen halben Tag (5 Std.) oder einen ganzen Tag (10 Std.) gebucht werden. Längere Nutzungszeiten sind nach Vereinbarung möglich. Bitte geben Sie ein konkretes Datum für die Veranstaltung an.</p>'
    },
    {
      modifier: 'half',
      fieldType: 'input',
      type: 'date',
      name: 'desiredDate',
      label: 'Wunschtermin',
      required: true
    },
    {
      modifier: 'half',
      fieldType: 'input',
      type: 'date',
      name: 'altDate',
      label: 'Alternativtermin'
    },
    {
      modifier: 'half',
      fieldType: 'input',
      type: 'time',
      name: 'startTime',
      label: 'Beginn des Events',
      required: true
    },
    {
      modifier: 'half',
      fieldType: 'input',
      type: 'time',
      name: 'endTime',
      label: 'Ende des Events',
      required: true
    },
    {
      modifier: 'half',
      fieldType: 'input',
      type: 'number',
      name: 'participants',
      label: 'Anzahl Teilnehmende',
      required: true,
      min: 1
    },
    {
      fieldType: 'input',
      name: 'room',
      label: 'Gewünschter Raum',
      placeholder: 'Forum, Studio, Foyer…',
      required: true
    },
    {
      fieldType: 'input',
      name: 'eventTitle',
      label: 'Titel',
      placeholder: 'Titel der geplanten Veranstaltung',
      required: true
    },
    {
      fieldType: 'input',
      name: 'eventFormat',
      label: 'Format',
      placeholder:
        'Veranstaltungsformat, z.B. Tagung, Symposium, Workshop, Kongress, Produktpräsentation, Jubiläum, Festakt,  Empfang, Gala, Pressekonferenz',
      required: true
    },
    {
      fieldType: 'input',
      name: 'partners',
      label: 'Partner*innen',
      placeholder: 'Projektträger*innen/Kooperationspartner*innen'
    },
    {
      modifier: 'half',
      fieldType: 'select',
      name: 'hasVips',
      label: 'Hochrangige Persönlichkeiten',
      options: [
        { value: 'nein', text: 'nein' },
        { value: 'ja', text: 'ja' }
      ]
    },
    {
      modifier: 'half',
      fieldType: 'input',
      name: 'vipsDetails',
      label: 'Wer? Sicherheits\nvorkehrungen?',
      placeholder: 'Wer wird erwartet? Welche besonderen Sicherheitsvorkehrungen sind notwending?'
    },
    {
      modifier: 'half',
      fieldType: 'select',
      name: 'isPublic',
      label: 'Öffentliche Veranstaltung',
      options: [
        { value: 'nein', text: 'nein' },
        { value: 'ja', text: 'ja' }
      ]
    },
    {
      modifier: 'half',
      fieldType: 'input',
      name: 'targetAudience',
      label: 'Zielgruppe',
      placeholder: 'An welche Zielgruppe richtet sich die Veranstaltung?'
    },
    {
      fieldType: 'infoText',
      copy: '<h3>KURZBESCHREIBUNG DER VERANSTALTUNG</h3><p>Die inhaltliche Ausrichtung Ihrer geplanten Veranstaltung muss dem Gesellschaftszweck des Futuriums entsprechen. Bitte erläutern Sie den für Sie naheliegenden Themenbezug und beschreiben Sie die Veranstaltung kurz.</p><h4>Themenbezug</h4>'
    },
    {
      fieldType: 'checkbox',
      name: 'topic_bildung',
      label: 'Bildung'
    },
    {
      fieldType: 'checkbox',
      name: 'topic_forschung',
      label: 'Forschung'
    },
    {
      fieldType: 'checkbox',
      name: 'topic_wissenschaft',
      label: 'Wissenschaft'
    },
    {
      fieldType: 'checkbox',
      name: 'topic_zukunft',
      label: 'Zukunftsaspekt'
    },
    {
      fieldType: 'textarea',
      name: 'description',
      label: 'Kurzbeschreibung und thematische Ausrichtung der Veranstaltung (max. 2500 Zeichen)',
      required: true
    },
    {
      fieldType: 'checkbox',
      name: 'newsletterConsent',
      label:
        'Ich stimme zu, dass meine personenbezogenen Daten für Informationsmails der Vermietungsabteilung des Futuriums genutzt werden dürfen. Mein Einverständnis kann ich jederzeit widerrufen. <a href="/de/datenschutz" target="_blank">Hier finden sie unsere Datenschutzerklärung</a>',
      required: true
    },
  ],
  submitText: 'Vermietungsanfrage abschicken'
};
